<template>
  <div>
    <div class="h-title-con">
      <div class="h-title">
        <span class="title-tip"></span>
        <span class="title-text">用户管理</span>
      </div>
      <div class="h-button-warpper">
        <span class="orgBtn btn-font" @click="search()"><i class="iconfont icon-chaxun"></i><label>查询</label></span>
        <span class="orgBtn btn-font" @click="reset()"><i class="iconfont icon-shuaxin1"></i><label>重置</label></span>
        <span class="orgBtn btn-font" @click="goNewPage()"><i class="iconfont icon-tianjia2"></i><label>新增</label></span>
        <up-load :action="action" :fileType="filename"></up-load>
      </div>
    </div>
    <div class="content-params" id="contentParams" :style="{height: isHidden}">
      <!-- 用户账号 -->
      <div class="params">
        <label class="custom_label">用户账号：</label>
        <span style="min-width:210px"><el-input placeholder="请输入用户账号" v-model="userSeach.account"></el-input></span>
      </div>
      <!-- 所属组织
      <div class="area-params">
          <label class="custom_label">所属组织：</label>
          <el-select class="area-select" v-model="organizeValue"  style="min-width:210px" clearable collapse-tags placeholder="请选择所属组织">
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
            <el-option
              @click.native="loadBrand(2)"
              v-for="item in organizeList"
              :key="item.organizeCode"
              :label="item.organizeName"
              :value="item.organizeCode">
            </el-option>
          </el-select>
      </div>-->
      <!-- 用户角色 -->
      <div class="area-params">
          <label class="custom_label">用户角色：</label>
          <el-select class="area-select"  v-model="userSeach.roleCode" style="min-width:210px" collapse-tags placeholder="请选择用户角色">
            <el-option
              @click.native="loadBrand(1)"
              v-for="item in roleList"
              :key="item.roleCode"
              :label="item.roleName"
              :value="item.roleCode">
            </el-option>
          </el-select>
      </div>
      <!-- 员工姓名 -->
      <div class="params">
        <label class="custom_label">员工姓名：</label>
        <span style="min-width:210px"><el-input placeholder="请输入员工姓名" v-model="userSeach.userName"></el-input></span>
      </div>
      <!-- 状态-->
      <div class="area-params">
          <label class="custom_label">状态：</label>
          <el-select class="area-select"  v-model="userSeach.status" style="min-width:210px" collapse-tags placeholder="请选择状态">
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
            <el-option
              v-for="item in statusData"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
      </div>
      <div class="area-params">
          <label class="custom_label">用户类型：</label>
          <el-select class="area-select"  v-model="userSeach.accountType" style="min-width:210px" collapse-tags placeholder="请选择用户类型">
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
            <el-option
              v-for="item in accountTypeData"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
      </div>
    </div>
    <div class="arrow_icon">
      <div class="border" @click="showAllParams">
        <i
          class="el-icon-arrow-down show-more-arrow"
          :class="[isHidden === 'auto'?'is-open':'']">
        </i>
      </div>
    </div>
  </div>
</template>

<script>
import { methodPost } from '../../../api/request.js'
import upLoad from './upload.vue'
export default {
  name: 'customParams',
  components: { upLoad },
  props: {
    queryType: {
      type: String
    },
    userSeach: {
      type: Object
    }
  },
  data() {
    return {
      filename: 'filename',
      isHidden: '40px',
      action: '/user/exImport',
      statusData: [
        {
          value: '',
          label: '全部'
        },
        {
          value: '1',
          label: '有效'
        },
        {
          value: '0',
          label: '无效'
        }
      ],
      accountTypeData: [
        {
          value: '',
          label: '全部'
        },
        {
          value: '1',
          label: '达能集团帐号'
        },
        {
          value: '0',
          label: '系统平台帐号'
        }
      ],
      organizeList: [],
      roleList: []
    }
  },
  created() {
    this.init()
  },
  mounted() {
    this.screenHeight = document.getElementById('contentParams').clientHeight
    window.onresize = () => {
      return (() => {
        if (document.getElementById('contentParams')) {
          this.screenHeight = document.getElementById('contentParams').clientHeight
        }
      })()
    }
  },
  methods: {
    /* 导出 */
    exports() {
      this.handlerChange('exports')
    },
    /* 重置 */
    reset() {
      this.userSeach.status = '1'
      this.userSeach.account = ''
      this.userSeach.roleCode = ''
      this.userSeach.userName = ''
      this.userSeach.accountType = ''
      const obj = {
        status: this.userSeach.status,
        account: this.userSeach.account,
        roleCode: this.userSeach.roleCode,
        userName: this.userSeach.userName,
        accountType: this.userSeach.accountType
      }
      this.$emit('query', obj)
    },
    /* 是否展示全部params */
    showAllParams() {
      this.isHidden = this.isHidden === '40px' ? 'auto' : '40px'
      setTimeout(() => {
        this.screenHeight = document.getElementById('contentParams').clientHeight
      }, 50)
    },
    /* 查询 */
    search() {
      this.handlerChange('search')
    },
    /* 初始化数据*/
    init() {
      this.loadBrand(1)
      this.loadBrand(2)
    },
    /* 组织和角色管理 */
    loadBrand(level) {
      if (level === 1) {
        methodPost('/role/simplelist', {}).then(res => {
          if (res.code === 0) {
            this.roleList = res.data
          } else {
            this.$message.error(res.message)
          }
        }).catch(res => {
          console.log(res)
        })
      } else if (level === 2) {
        methodPost('/sysOrganize/getSysOrganizeTree', {}).then(res => {
          if (res.code === 0) {
            console.log(res.data.children)
            this.organizeList = res.data.children
          } else {
            this.$message.error(res.message)
          }
        }).catch(res => {
          console.log(res)
        })
      }
    },
    /* 更改条件查询 */
    handlerChange(type) {
      const params = {
        status: this.userSeach.status, // 状态
        account: this.userSeach.account,
        roleCode: this.userSeach.roleCode,
        userName: this.userSeach.userName,
        accountType: this.userSeach.accountType
      }
      if (type === 'search') {
        this.$emit('query', params)
      }
    },
    /* 新增页面 */
    goNewPage() {
      this.$router.push('/userManagementList/add')
    }
  }
}
</script>

<style type="text/scss" lang="scss" scoped>
.h-title-con{
  display:block;
  .h-title{
    float:left;
  }
  .h-button-warpper{
    padding-top:8px;
  }
}
.content-params {
  padding:5px 20px;
  display: flex;
  align-items: center;
  max-width: 900px;
  flex-wrap: wrap;
  overflow: hidden;
  .params {
    min-width:340px;
    margin: 5px 0;
    font-size: 0;
  }
  .area-params {
    width: 340px;
    margin: 5px 0;
    font-size: 0;
  }
  .custom_label {
    min-width: 80px;
    display:inline-block;
    font-size: 14px;
    font-weight:700;
    text-align: right;
    color:#606266;
    i {
      color: red;
      font-style: normal;
      vertical-align: middle;
    }
  }
}
.arrow_icon {
  position:relative;
  background:#fff;
  bottom: -5px;
  height:18px;
  border-radius:6px 6px 0 0;
  text-align: center;
  z-index:9;
  margin:0 20px;
  box-sizing: border-box;
  // border-top: 1px solid rgba(111, 107, 107, 0.14);
  .border {
    cursor: pointer;
    display: inline-block;
    width:40px;
    height:16px;
    background: #ebeef5;
    left: calc(50% - 20px);
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    .show-more-arrow{
      position: relative;
      top: -1px;
      transition: 0.3s ease-in-out;
      &.is-open {
        transform: rotate(-180deg);
      }
    }
  }
}
.separator {
  border-top: 1px solid #c0c4cc;
  margin: 0 2px;
  width: 6px;
  height: 5px;
  display: inline-block;
}
</style>
<style>
.params .el-input{
    width:210px!important;
 }
.avatar-uploader{
   display: flex;
}
</style>



// WEBPACK FOOTER //
// src/_app/wwka/src/views/userManagementList/customParams/indexTimes.vue